// What the chat button does (ChatEntry on the server, docs/CHATWOOT.md,
// Website chat). The arm is the layout's <meta name="gwmc:chat">: "web"
// (CHAT_ENTRY=webchat, the on-page chat Aider answers) or "wa" (WhatsApp only,
// as before 25 Oct 2026, and the kill switch).
//
//                   desktop                         phone
//   wa, no token    the WhatsApp dialog             wa.me
//   web             the on-page chat ("web")        "Chat here" or "WhatsApp"
//                                                   ("choose"), then whatever
//                                                   they chose last time
//
// Robin, 25 Oct 2026: "we prob dont have visibility on desktop app", so a
// desktop is never sniffed for WhatsApp; it is offered (Continue on
// WhatsApp), never assumed.

const CHOICE_KEY = 'gwmc.chat.choice'
const REF_KEY = 'gwmc.chat.ref'
// No I, O, 0 or 1: the reference is read and maybe retyped.
const REF_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
export const REF_PATTERN = /^[A-HJ-NP-Z2-9]{8}$/

export const chatArm = (doc = globalThis.document) => {
  try {
    const meta = doc && doc.querySelector('meta[name="gwmc:chat"]')
    return meta && meta.getAttribute('content') === 'web' ? 'web' : 'wa'
  } catch (e) {
    return 'wa'
  }
}

// 'wa.me' (follow the link), 'whatsapp' (the WhatsApp dialog), 'web' (open
// the on-page chat) or 'choose' (the phone's two buttons).
export const entryRoute = ({ arm, token, mobile, choice }) => {
  if (arm !== 'web' || !token) return mobile ? 'wa.me' : 'whatsapp'
  if (!mobile) return 'web'
  if (choice === 'web') return 'web'
  if (choice === 'wa') return 'wa.me'
  return 'choose'
}

function safeStorage () {
  try { return globalThis.localStorage || null } catch (e) { return null }
}

// The phone's last choice, 'web' or 'wa', or null. Any storage failure just
// asks again.
export const rememberedChoice = (storage = safeStorage()) => {
  try {
    const value = storage && storage.getItem(CHOICE_KEY)
    return value === 'web' || value === 'wa' ? value : null
  } catch (e) {
    return null
  }
}

export const rememberChoice = (choice, storage = safeStorage()) => {
  try { if (storage) storage.setItem(CHOICE_KEY, choice) } catch (e) { /* private window */ }
}

const randomRef = (random = globalThis.crypto) => {
  const bytes = new Uint8Array(8)
  if (random && typeof random.getRandomValues === 'function') random.getRandomValues(bytes)
  else for (let i = 0; i < 8; i++) bytes[i] = Math.floor(Math.random() * 256)
  return Array.from(bytes, b => REF_ALPHABET[b % REF_ALPHABET.length]).join('')
}

// This browser's chat reference: kept, so a returning visitor is the same
// contact; a fresh one when storage is blocked (still one chat per page).
let pageRef = null
export const chatRef = (storage = safeStorage(), random) => {
  try {
    const saved = storage && storage.getItem(REF_KEY)
    if (saved && REF_PATTERN.test(saved)) return saved
    const ref = randomRef(random)
    if (storage) storage.setItem(REF_KEY, ref)
    return ref
  } catch (e) {
    pageRef = pageRef || randomRef(random)
    return pageRef
  }
}

// The WhatsApp message "Continue on WhatsApp" opens with. The server finds
// the chat by "ref XXXXXXXX" (Chatwoot::WebsiteChat::REF_IN_TEXT).
export const continueText = ref => `Hi GoWashMyCar, carrying on from the website chat (ref ${ref})`
